import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { MatMenuTrigger } from '@angular/material/menu';
import { NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { NotificationService } from './shared/services/notification-service/notification.service';
import { PropertyMatrixSharedService } from './property-matrix-shared.service';
import { RoleBasedAccessDto } from '../app/services/property-matrixV2/models';
import { UserManagementService } from './services/property-matrixV2/services';
import { AccountService } from './services/auth/account-service';
import { UserService } from './services/user.service';
import { User } from './models/User';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'Property Pro Web';
  isLoggedIn: boolean;
  user: User;
  subscription: Subscription;
  navbar: HTMLElement;
  navPos: number;
  adminActive: boolean = false;
  adminPageTitle: string | null | undefined;
  mainMenuOpen = false;
  isSmallScreenMain = false;
  adminMenuOpen = false;
  isSmallScreenAdmin = false;
  showUserTab: boolean = false;
  roleBasedAccessDto: RoleBasedAccessDto;

  constructor(
    private router: Router,
    private http: HttpClient,
    private pageTitle: Title,
    private userService: UserService,
    private accountService: AccountService,
    private userManagementService: UserManagementService,
    private keycloakService: KeycloakService,
    private sharedService: PropertyMatrixSharedService,
    private notificationService: NotificationService,
  ) {
    keycloakService.keycloakEvents$.subscribe({
      next(event) {
        if (event.type == KeycloakEventType.OnTokenExpired) {
          keycloakService.updateToken(20);
        }
      }
    });
  }

  ngOnInit(): void {
    this.user = this.sharedService.getUserModel();

    this.isSmallScreenMain = window.innerWidth < 1341;
    this.isSmallScreenAdmin = window.innerWidth < 801;

    this.adminActive = sessionStorage.getItem("adminNav") === "true";
    if (this.router.url.startsWith('/admin')) {
      this.adminActive = true;
    }

    this.keycloakService.isLoggedIn().then((loggedIn: boolean) => {
      this.isLoggedIn = loggedIn;
      if (this.isLoggedIn) {
        this.accountService.setUserToken().then(() => {
          if (this.router.url.startsWith('/admin')) {
            this.getAdminNavStatus();
          }
        });
      }
    });

    this.setTitle();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkAdminRoute();
        this.mainMenuOpen = false;
        this.adminMenuOpen = false;
      }
    });
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setTitle() {
    if (!this.pageTitle.getTitle()) {
      this.pageTitle.setTitle('Property Matrix')
    }
  }

  checkAdminRoute(): void {
    if (this.router.url.startsWith('/admin')) {
      this.adminActive = true;
    } else {
      this.adminActive = false;
    }
    this.showUserTabPerUserRole(this.roleBasedAccessDto);
  }

  goToRegister() {
    this.router.navigate(['/register-as']);
  }

  onClickLogin() {
    sessionStorage.clear();
    this.keycloakService.login();
  }

  onClickLogout() {
    sessionStorage.clear();
    this.keycloakService.logout();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isSmallScreenMain = window.innerWidth < 1341;
    if (!this.isSmallScreenMain) {
      this.mainMenuOpen = false;
    }

    this.isSmallScreenAdmin = window.innerWidth < 801;
    if (!this.isSmallScreenAdmin) {
      this.adminMenuOpen = false;
    }
  }

  toggleMainMenu() {
    this.mainMenuOpen = !this.mainMenuOpen;
  }

  toggleAdminMenu() {
    this.adminMenuOpen = !this.adminMenuOpen;
  }

  enableAdminNav() {
    sessionStorage.setItem("adminNav", "true");
    this.adminActive = true;
  }

  disableAdminNav() {
    sessionStorage.setItem("adminNav", "false");
    this.adminActive = false;
  }

  getAdminNavStatus(): void {
    let roleBasedAccessDto: RoleBasedAccessDto;
    this.accountService.getDecodedUserToken().then((token: any) => {
      if (token != null) {
        roleBasedAccessDto = JSON.parse(token);
        this.roleBasedAccessDto = roleBasedAccessDto;
        if (roleBasedAccessDto.endorsed === false || roleBasedAccessDto.endorsed === null) {
          this.notificationService.showConfirmMessage("User not endorsed",
            "The current user, is not endorsed. Therefore the user is blocked and will not go to the admin portal.", "OK", "Close").then(result => {
              this.onClickLogout();
            });
        }

        this.showUserTabPerUserRole(this.roleBasedAccessDto);

        if (this.roleBasedAccessDto.roles?.includes('Planner Portal Administrator')) {
          this.adminPageTitle = roleBasedAccessDto.userFullName;
        } else {
          this.adminActive = false;
        }


      }
    });
  }

  delayedClose(trigger: MatMenuTrigger) {
    setTimeout(() => {
      trigger.closeMenu();
    }, 500);
  }

  logout() {
    this.sharedService.logout();
  }

  showUserTabPerUserRole(roleBasedAccessDto: RoleBasedAccessDto): void {
    if (roleBasedAccessDto == undefined) {
      this.userManagementService.apiV1UserManagementGetUserTokenGet().subscribe(roleBasedAccessDto => {
        this.roleBasedAccessDto = roleBasedAccessDto;
        let foundRole: boolean = [
          'Head Administrator',
          'Planner Portal Administrator',
          'Consultant Administrator',
          'Admin Portal Administrator',
          'Head Of Finances',
          'Senior Agent',
          'Senior Planner'
        ].some(role => this.roleBasedAccessDto.roles?.includes(role));
        if (foundRole == true) {
          this.showUserTab = true;
        }
      });
    } else {
      let foundRole: boolean = [
        'Head Administrator',
        'Planner Portal Administrator',
        'Consultant Administrator',
        'Admin Portal Administrator',
        'Senior Planner',
        'Head Of Finances',
        'Senior Agent'
      ].some(role => this.roleBasedAccessDto.roles?.includes(role));
      if (foundRole == true) {
        this.showUserTab = true;
      }
    }
  }
}
